import { ReactNode, RefObject } from 'react';

import { cx } from '@libs/classnames';
import { useSticky } from '@libs/hooks/useSticky';

import styles from './SiteHeader.module.css';

export type Props = {
  className?: string;
  siteLogo: ReactNode;
  centeredTitle?: ReactNode;
  actions?: ReactNode;
};

export function SiteHeader({ className, siteLogo, centeredTitle, actions }: Props) {
  const { ref, isSticky } = useSticky();

  return (
    <div
      ref={ref as RefObject<HTMLDivElement>}
      className={cx(className, styles.header, { [styles.sticky]: isSticky })}
    >
      <div className={styles.content}>
        <div className={styles.leftSide}>{siteLogo}</div>
        {centeredTitle && <div className={styles.center}>{centeredTitle}</div>}
        <div className={styles.rightSide}>{actions}</div>
      </div>
    </div>
  );
}
